module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Mobile-Banner@2x.a8b83655.jpg";